import { getOnboardingStateSessionId } from "./onboardingSessionHelper";
import { saveAiTonesData, getTonesData } from "../api/onboarding";

export const getMappedTone = (selectedTemplate) => {
  const toneMap = {
    playful: 'Friendly',
    modern: 'Informative',
    professional: 'Professional',
    bold: 'Persuasive',
    classic: 'Thoughtful',
  };

  const mappedTone = toneMap[selectedTemplate] || 'neutral';
  return mappedTone;
}

  export const saveAiTones = async (tones) => {
    const payload = {
      onboardingSessionId: getOnboardingStateSessionId(),
      aiToneTexts: JSON.stringify(tones)
    }
      try {
        await saveAiTonesData(payload)
      }
      catch (error) {
        console.error('Error saving AI tones', error)
    }
  }

  export const overwriteSelectedTone = (tones, aiSelectedTone, template) => {
    const obj = tones
    obj.tones[aiSelectedTone.toLowerCase()].title = template?.sections?.hero?.title || ''
    obj.tones[aiSelectedTone.toLowerCase()].shortDescription = template?.sections?.hero?.subtitle || ''
    obj.tones[aiSelectedTone.toLowerCase()].button1text = template?.sections?.hero?.ctaText || ''
    return obj
  }
  
  export const getToneStrings = async (templateStyle, template, websiteDetails) => {
    const tonesPayload = {
      metaData: {
        businessName: websiteDetails.data.title,
        goal: websiteDetails.data.prompt,
        category: websiteDetails.data.category,
      },
      functionCallName: "generate_tone_blocks",
    }
    const tonesData = await getTonesData(tonesPayload)
    try {
      const tones = JSON.parse(tonesData.arguments)
      const aiSelectedTone = getMappedTone(templateStyle)
      const saveTones = overwriteSelectedTone(tones, aiSelectedTone, template)
      saveAiTones(saveTones)
      return saveTones
    } catch (error) {
      console.error('Error parsing tones data', error)
    }
  }